export const PREMIERE_APP_ROUTES = {
  ALL: (workspaceId: string) => `/${workspaceId}/all`,
  ALL_CLIP: (workspaceId: string, clipId: string) => `/${workspaceId}/all/c/${clipId}`,
  BOARD: (workspaceId: string, boardId: string) => `/${workspaceId}/b/${boardId}`,
  BOARD_CLIP: (workspaceId: string, boardId: string, clipId: string) => `/${workspaceId}/b/${boardId}/c/${clipId}`,
  FAVORITES: (workspaceId: string) => `/${workspaceId}/favorites`,
  FAVORITES_CLIP: (workspaceId: string, clipId: string) => `/${workspaceId}/favorites/c/${clipId}`,
  LIBRARY: (workspaceId: string, libraryId: string) => `/${workspaceId}/l/${libraryId}`,
  LIBRARY_CLIP: (workspaceId: string, libraryId: string, clipId: string) =>
    `/${workspaceId}/l/${libraryId}/c/${clipId}`,
  RECENT: (workspaceId: string) => `/${workspaceId}/recent`,
  RECENT_CLIP: (workspaceId: string, clipId: string) => `/${workspaceId}/recent/c/${clipId}`,
  ROOT: (workspaceId: string) => `/${workspaceId}`,
};
